import { AccessDenied } from '@/shared/components';
import { checkIsAccessDeniedError } from '@/shared/utils/error-handler';
import { cn, EmptyState, Flex, type IEmptyStateProps } from '@kognitos/lattice';
import { useTranslation } from 'react-i18next';

interface ErrorRendererProps {
  className?: string;
  error: Error;
  title: string;
  emptyStateProps: IEmptyStateProps;
  containerClassName?: string;
}

export const ErrorRenderer = ({
  error,
  className,
  title,
  emptyStateProps,
  containerClassName,
}: ErrorRendererProps) => {
  const { t: tCommon } = useTranslation('common');
  const isAccessDeniedError = checkIsAccessDeniedError(error);

  return (
    <Flex
      justify="center"
      align="center"
      className={cn('w-full', containerClassName)}
    >
      {isAccessDeniedError ? (
        <AccessDenied className={cn('w-md max-h-60', className)} />
      ) : (
        <EmptyState
          icon="AlertCircle"
          title={title || tCommon('common.error.error')}
          {...emptyStateProps}
          className={cn('w-md max-h-60', className)}
        />
      )}
    </Flex>
  );
};
